var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientOfficeNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file",
    clipPath: "url(#clip0_15010_243766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.6665 2H3.99984C3.64622 2 3.30708 2.14048 3.05703 2.39052C2.80698 2.64057 2.6665 2.97971 2.6665 3.33333V14C2.6665 14.3536 2.80698 14.6928 3.05703 14.9428C3.30708 15.1929 3.64622 15.3333 3.99984 15.3333H11.9998C12.3535 15.3333 12.6926 15.1929 12.9426 14.9428C13.1927 14.6928 13.3332 14.3536 13.3332 14V6.66667M8.6665 2L13.3332 6.66667M8.6665 2V6.66667H13.3332",
    stroke: "#0C66E4",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15010_243766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.666016)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientOfficeNote);
export default __webpack_public_path__ + "static/media/clientOfficeNote.b24571ca6b32d2b5e26cf8bedad312e9.svg";
export { ForwardRef as ReactComponent };